import { useState } from 'react';
import TitleForms from '../../GenericBaseForms/TitleForms/TitleForms';
import React from 'react';
import './ProductViolationsFormComponent.scss';
import { useWindowSize } from '../../../../hooks/useWindowSize';
import { ProductInfo } from '../../../../redux/AppReducer';

interface IProductViolationsForm {
	productState: ProductInfo;
}
// interface IViolations {
// 	change: string;
// 	description: string | React.ReactElement;
// 	action: string | React.ReactElement;
// 	id: string;
// }

const ProductViolationsFormComponent: React.FC<IProductViolationsForm> = ({ productState }) => {
	const [isVisible, setVisibility] = useState<boolean>(true);

	const toggleVisibility = () => {
		setVisibility(!isVisible);
	};
	const { width } = useWindowSize();
	const FULL_SIZE_SCREEN_WIDTH = 768;
	const isMobile = width < FULL_SIZE_SCREEN_WIDTH;
	// const ViolationsArray = [
	// 	{
	// 		change: 'Allergen warning missing or incomplete',
	// 		action: (
	// 			<>
	// 				Please contact{' '}
	// 				<a href='mailto:Standards@newhope.com' target='_blank' rel='noreferrer'>
	// 					{' '}
	// 					Standards@newhope.com.
	// 				</a>{' '}
	// 				to resolve this label issue.
	// 			</>
	// 		),
	// 		description:
	// 			'Product contains an ingredient that requires an allergen declaration which is not present. An allergen declaration is required for all products that contain milk, egg, fish, shellfish, wheat, peanuts, soy, tree nuts, or sesame.',
	// 		id: 'allergenMissing'
	// 	},
	// 	{
	// 		change: 'Claims or TM logo requires certification',
	// 		action: (
	// 			<>
	// 				Please contact{' '}
	// 				<a href='mailto:Standards@newhope.com' target='_blank' rel='noreferrer'>
	// 					{' '}
	// 					Standards@newhope.com.
	// 				</a>{' '}
	// 				to resolve this label issue.
	// 			</>
	// 		),
	// 		description:
	// 			'Product label indicates the product is certified organic, certified gluten free and/or non-GMO verified/certified. The supporting certificatedocumentation is required or the label may require appropriate revisions.',
	// 		id: 'claimsLogoRequiresCertification'
	// 	},
	// 	{
	// 		change: 'Facts panel missing or incorrect',
	// 		action: (
	// 			<>
	// 				Please contact{' '}
	// 				<a href='mailto:Standards@newhope.com' target='_blank' rel='noreferrer'>
	// 					{' '}
	// 					Standards@newhope.com.
	// 				</a>{' '}
	// 				to resolve this label issue.
	// 			</>
	// 		),
	// 		description:
	// 			'Facts panel is missing and is required; or existing panel is missing required information and/or contains incorrect information.',
	// 		id: 'factPanelMissing'
	// 	},
	// 	{
	// 		change: 'Ingredients list missing or incorrect',
	// 		action: (
	// 			<>
	// 				Please contact{' '}
	// 				<a href='mailto:Standards@newhope.com' target='_blank' rel='noreferrer'>
	// 					{' '}
	// 					Standards@newhope.com.
	// 				</a>{' '}
	// 				to resolve this label issue.
	// 			</>
	// 		),
	// 		description:
	// 			'Ingredients list includes items that must be broken down into its sub-ingredient components; ingredients declaration is incorrect; or product contains more than one ingredient making an ingredients list required, and it is missing.',
	// 		id: 'ingredientsListMissing'
	// 	},

	// 	{
	// 		change: 'Misuse of an FDA approved health claim',
	// 		action: (
	// 			<>
	// 				Please contact{' '}
	// 				<a href='mailto:Standards@newhope.com' target='_blank' rel='noreferrer'>
	// 					{' '}
	// 					Standards@newhope.com.
	// 				</a>{' '}
	// 				to resolve this label issue.
	// 			</>
	// 		),
	// 		description:
	// 			'The product may meet the requirements to use an U.S. FDA approved health claim, but the language of the claim does not align with the language	approved for use by the U.S. FDA.',
	// 		id: 'misuseFDAApprovedHealthClaim'
	// 	},
	// 	{
	// 		change: 'Organic certifying agent missing',
	// 		action: (
	// 			<>
	// 				Please contact{' '}
	// 				<a href='mailto:Standards@newhope.com' target='_blank' rel='noreferrer'>
	// 					{' '}
	// 					Standards@newhope.com.
	// 				</a>{' '}
	// 				to resolve this label issue.
	// 			</>
	// 		),
	// 		description:
	// 			'Product label includes organic claims that require the product be Certified Organic with the certifying agent identified on the information panel. The certyfiing agent does not appear on this product label and it is required. If the product is not Certified Organic, the organic claim(s) need to be removed.',
	// 		id: 'organicCertifyingAgentMissing'
	// 	},

	// 	{
	// 		change: 'Statement of identity missing',
	// 		action: (
	// 			<>
	// 				Please contact{' '}
	// 				<a href='mailto:Standards@newhope.com' target='_blank' rel='noreferrer'>
	// 					{' '}
	// 					Standards@newhope.com.
	// 				</a>{' '}
	// 				to resolve this label issue.
	// 			</>
	// 		),
	// 		description:
	// 			'The statement of identity is the common or usual name of the food or beverage. An appropriate descriptive name, that is not misleading, is missing. If the product is a dietary supplement, a "SUPPLEMENT" statement of identity on the primary panel of the label is missing.',
	// 		id: 'statementIdentityMissing'
	// 	},
	// 	{
	// 		change: 'Ingredient standards ',
	// 		action: (
	// 			<>
	// 				Product is not eligible for exhibit due to prohibited ingredients. Please refer to the NHN
	// 				Ingredient Standards{' '}
	// 				<a
	// 					href='https://standards.newhope.com/ingredient-standards-guidelines'
	// 					target='_blank'
	// 					rel='noreferrer'
	// 				>
	// 					https://standards.newhope.com/ingredient-standards-guidelines
	// 				</a>
	// 				.
	// 			</>
	// 		),
	// 		description:
	// 			'Product contains at least one ingredient that is prohibited by New Hope Ingredient Standards.',
	// 		id: 'ingredientStandards'
	// 	},

	// 	{
	// 		change: 'Disease claims',

	// 		action: (
	// 			<>
	// 				Please contact{' '}
	// 				<a href='mailto:Standards@newhope.com' target='_blank' rel='noreferrer'>
	// 					{' '}
	// 					Standards@newhope.com.
	// 				</a>{' '}
	// 				to resolve this label issue.
	// 			</>
	// 		),
	// 		description:
	// 			'Product includes a claim that establishes the intended use of the product as a drug. It has also been determined that the product does not qualify for an FDA approved health claim. New Hope Network Standards do not permit products to make disease or drug-like clams.',
	// 		id: 'diseaseClaims'
	// 	},
	// 	{
	// 		change: 'Contains banned ingredients',

	// 		action: (
	// 			<>
	// 				Product is not eligible for exhibit due to prohibited ingredients. Please refer to the NHN
	// 				Ingredient Standards .
	// 				<a
	// 					href='https://standards.newhope.com/ingredient-standards-guidelines '
	// 					target='_blank'
	// 					rel='noreferrer'
	// 				>
	// 					{' '}
	// 					https://standards.newhope.com/ingredient-standards-guidelines.
	// 				</a>{' '}
	// 			</>
	// 		),
	// 		description:
	// 			'Product includes a claim that establishes the intended use of the product as a drug. It has also been determined that the product does not qualify for an FDA approved health claim. New Hope Network Standards do not permit products to make disease or drug-like clams.',
	// 		id: 'containsBannedIngredients'
	// 	}
	// ];

	// const violations: IViolations[] = ViolationsArray.filter(
	// 	violation => productState.violations[violation.id]
	// ); commented because BP-1826
	const showGeneralViolations = productState.status === 'Product Not Approved';
	//if (violations.length > 0) { // this is commented because of BP-1826
	if (showGeneralViolations) {
		return (
			<div className='product-violations-form'>
				<TitleForms
					isVisible={isVisible}
					titleText='Violations'
					toggleVisibility={toggleVisibility}
					readOnly
					warning
				></TitleForms>
				{!isMobile && isVisible ? (
					<>
						<p className='helper-text'>
							Your product may have one or more violations, please reach out to your Standards
							specialist at{' '}
							<a href='mailto:Standards@newhope.com' target='_blank' rel='noreferrer'>
								standards@newhope.com
							</a>{' '}
							for more information.
						</p>
						{/* <table>
							<thead>
								<tr>
									<th>
										<SecondaryLabelForm text='Change'></SecondaryLabelForm>
									</th>
									<th>
										<SecondaryLabelForm text='Description'></SecondaryLabelForm>
									</th>
									<th>
										<SecondaryLabelForm text='Action'></SecondaryLabelForm>
									</th>
								</tr>
							</thead>
							<tbody>
								{violations.map((violation, index) => (
									<tr key={index + productState.id}>
										<td>{violation.change}</td>
										<td>{violation.description}</td>
										<td>{violation.action}</td>
									</tr>
								))}
							</tbody>
						</table> */}
					</>
				) : isMobile && isVisible ? (
					<div className='violations-container'>
						<p className='helper-text'>
							Your product may have one or more violations, please reach out to your Standards
							specialist at
							<a href='mailto:Standards@newhope.com' target='_blank' rel='noreferrer'>
								{' '}
								standards@newhope.com
							</a>{' '}
							for more information.
						</p>
						{/* {violations.map((violations, index) => (
							<div key={index + productState.id} className='violation-container'>
								<div className='violation-element'>
									<SecondaryLabelForm text='Change'></SecondaryLabelForm>
									<p> {violations.change}</p>
								</div>

								<div className='violation-element'>
									<SecondaryLabelForm text='Description'></SecondaryLabelForm>
									<p> {violations.description}</p>
								</div>

								<div className='violation-element'>
									<SecondaryLabelForm text='Action'></SecondaryLabelForm>
									<p> {violations.action}</p>
								</div>
								<div className='separator'></div>
							</div>
						))} */}
					</div>
				) : (
					<></>
				)}
			</div>
		);
	}
	return null;
};

export default React.memo(ProductViolationsFormComponent);
